module.exports = __webpack_public_path__ + "img/atm.b29e087e.png";